import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AllianceOfferInfo from "./component";
import { updateLeadSource } from "../settings/actions";
import { fetchAllianceDetails } from "./actions";
import { withRouter } from "react-router-dom";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAllianceDetailsConnect: fetchAllianceDetails,
    updateLeadSourceConnect: updateLeadSource
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AllianceOfferInfo));
